"use strict";

var _slicedToArray = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var notification_action_1 = require("../actions/notification.action");
var helpers_1 = require("../helpers");
var NotificationList_1 = __importDefault(require("./NotificationList"));
var NotificationSetting_1 = __importDefault(require("./NotificationSetting"));
var NoticeList_1 = __importDefault(require("./NoticeList"));
function Notification(_ref) {
  var layerClose = _ref.layerClose;
  var _ref2 = (0, hooks_1.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    badge = _ref3[0],
    setBadge = _ref3[1];
  var _ref4 = (0, hooks_1.useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    show = _ref5[0],
    setshow = _ref5[1];
  var _ref6 = (0, hooks_1.useState)("COMPONENT_LIST"),
    _ref7 = _slicedToArray(_ref6, 2),
    step = _ref7[0],
    setStep = _ref7[1];
  var ref = (0, hooks_1.useRef)(null);
  (0, hooks_1.useEffect)(function () {
    function handleDocumentClick(e) {
      if (show && (!ref.current || !ref.current.contains(e.target))) {
        setshow(false);
      }
    }
    document.addEventListener("click", handleDocumentClick);
    return function () {
      return document.removeEventListener("click", handleDocumentClick);
    };
  }, [show]);
  (0, hooks_1.useEffect)(function () {
    // 페이지 로드 시 뱃지 상태 업데이트
    (0, notification_action_1.fetchBadge)().then(function (response) {
      if (step === 'COMPONENT_LIST') {
        setBadge(response.data.badge_flag ? true : false);
      }
    }).catch(function () {
      return setBadge(false);
    });
  }, []);
  (0, hooks_1.useEffect)(function () {
    if (layerClose) {
      setshow(false);
    }
  }, [layerClose, setshow]);
  var handleStepChange = (0, hooks_1.useCallback)(function (step) {
    if (['COMPONENT_LIST', 'COMPONENT_NOTICE'].indexOf(step) !== -1) {
      (0, helpers_1.setSessionStorage)("component_state", {
        componentState: step
      });
    }
    if (step === 'COMPONENT_LIST') {
      setBadge(false);
    }
    setStep(step);
  }, []);
  var handleShowChange = (0, hooks_1.useCallback)(function () {
    var sessionStorage = (0, helpers_1.getSessionStorage)("component_state");
    if (!sessionStorage) {
      if ((0, helpers_1.getAuthInfo)().user_id === '') {
        // 비로그인시 안내 탭 디폴트로
        setStep('COMPONENT_NOTICE');
      }
    } else {
      if (sessionStorage.componentState) {
        setStep(sessionStorage.componentState);
      } else {
        // 정책 확인 필수
        if ((0, helpers_1.getAuthInfo)().user_id === '') {
          setStep('COMPONENT_NOTICE');
        } else {
          setStep('COMPONENT_LIST');
        }
      }
    }
    setshow(!show);
    if (show === false && step === 'COMPONENT_LIST' && (!sessionStorage || sessionStorage.componentState === 'COMPONENT_LIST')) {
      setBadge(false);
      (0, helpers_1.setClickLogapi)("noti_00000001", {
        button_type: "badge"
      });
    }
  }, [show]);
  return (0, preact_1.h)("div", null, (0, preact_1.h)("div", {
    className: "noticeArea ".concat(show ? 'on' : ''),
    ref: ref
  }, (0, preact_1.h)("button", {
    className: "btn-notice ".concat(badge ? 'new' : ''),
    tip: "\uC54C\uB9BC",
    onClick: handleShowChange
  }, (0, preact_1.h)("span", null, "\"\uC54C\uB9BC\"")), show && (0, preact_1.h)("div", {
    className: "feed_layer",
    style: {
      display: show ? "block" : "none"
    }
  }, (0, preact_1.h)(NotificationList_1.default, {
    onStepChange: handleStepChange,
    userId: (0, helpers_1.getAuthInfo)().user_id,
    badge: badge,
    step: step,
    style: {
      display: step === "COMPONENT_LIST" ? "block" : "none"
    }
  }), step === "COMPONENT_SETTING" && (0, preact_1.h)(NotificationSetting_1.default, {
    onStepChange: handleStepChange
  }), step === "COMPONENT_NOTICE" && (0, preact_1.h)(NoticeList_1.default, {
    onStepChange: handleStepChange
  }))));
}
exports.default = Notification;